import { Component, Input, OnInit } from '@angular/core';
import {
  DraftIncomeSource,
  IncomeStreamType,
  IncomeSourceSubType,
  IncomeWizardPayFrequency,
  draftStreamTypeString,
  draftSubTypeString,
  PayrollDetail,
  BanksyncDetail,
  DocUploadDetail,
  WorkNumberDetail,
} from '../models/argyle';

@Component({
  selector: 'app-income-draft-card',
  templateUrl: './income-draft-card.component.html',
  styleUrls: ['./income-draft-card.component.less'],
})
export class IncomeDraftCardComponent implements OnInit {
  @Input() draft: DraftIncomeSource;

  payrollDetail: PayrollDetail | null = null;
  banksyncDetail: BanksyncDetail | null = null;
  docUploadDetail: DocUploadDetail | null = null;
  workNumberDetail: WorkNumberDetail | null = null;

  // Expose enums to template
  StreamType = IncomeStreamType;
  SubType = IncomeSourceSubType;

  ngOnInit(): void {
    this.parseDetail();
  }

  get headerTitle(): string {
    switch (this.draft.streamType) {
      case IncomeStreamType.PayrollSync:
        return `Payroll : ${this.draft.employerName || ''}`;
      case IncomeStreamType.BankSync:
        return `Banking : ${this.draft.employerName || ''}`;
      case IncomeStreamType.DocUpload:
        return `Document : ${this.docTypeLabel}`;
      case IncomeStreamType.WorkNumber:
        return 'Equifax Work Number Employment Verification';
      default:
        return draftStreamTypeString(this.draft.streamType);
    }
  }

  get docTypeLabel(): string {
    switch (this.draft.subType) {
      case IncomeSourceSubType.Paystubs: return 'Paystubs';
      case IncomeSourceSubType.W2: return 'W-2';
      case IncomeSourceSubType.Form1099: return '1099';
      default: return (this.draft.status || '').toUpperCase();
    }
  }

  get subTypeLabel(): string {
    return draftSubTypeString(this.draft.subType);
  }

  get exclusionBannerText(): string {
    const reason = this.draft.exclusionReasonText?.trim();
    return reason ? `Excluded — ${reason}` : 'Excluded';
  }

  get payFrequencyLabel(): string {
    switch (this.draft.payFrequency) {
      case IncomeWizardPayFrequency.Weekly: return 'Weekly';
      case IncomeWizardPayFrequency.BiWeekly: return 'Bi-Weekly';
      case IncomeWizardPayFrequency.SemiMonthly: return 'Semi-Monthly';
      case IncomeWizardPayFrequency.Monthly: return 'Monthly';
      case IncomeWizardPayFrequency.Annual: return 'Annual';
      default: return 'Unknown';
    }
  }

  private parseDetail(): void {
    if (!this.draft.detailJson) return;
    try {
      const raw = JSON.parse(this.draft.detailJson);
      const parsed = this.toCamelCase(raw);
      switch (this.draft.streamType) {
        case IncomeStreamType.PayrollSync:
          this.payrollDetail = parsed as PayrollDetail;
          break;
        case IncomeStreamType.BankSync:
          this.banksyncDetail = parsed as BanksyncDetail;
          break;
        case IncomeStreamType.DocUpload:
          this.docUploadDetail = parsed as DocUploadDetail;
          break;
        case IncomeStreamType.WorkNumber:
          this.workNumberDetail = parsed as WorkNumberDetail;
          break;
      }

    } catch {
      // DetailJson malformed — card will render header-only
      console.error(this.draft);
    }
  }

  private toCamelCase(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(item => this.toCamelCase(item));
    }
    if (obj !== null && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc, key) => {
        const camel = key.charAt(0).toLowerCase() + key.slice(1);
        acc[camel] = this.toCamelCase(obj[key]);
        return acc;
      }, {} as any);
    }
    return obj;
  }
}
